import {api} from 'api/setup';
import {getCookie, setCookie} from 'react-use-cookie';
import {StorageKeyEnum} from 'types';
import {TokenResult} from 'types';

export const authUtil = {
  login: (data: TokenResult) => {
    setCookie(StorageKeyEnum.ACCESS_TOKEN, data.access);
    setCookie(StorageKeyEnum.REFRESH_TOKEN, data.refresh);
    return true;
  },
  logout: async () => {
    try {
      const refreshToken = getCookie(StorageKeyEnum.REFRESH_TOKEN);
      if (refreshToken) {
        await api.post('/logout', {
          refresh: getCookie(StorageKeyEnum.REFRESH_TOKEN),
        });
      }
    } catch (error) {
    } finally {
      if (typeof window !== 'undefined') window.location.reload();

      clearTokens();
    }

    return true;
  },
  clear: clearTokens,
  getAccessToken: () => {
    return getCookie(StorageKeyEnum.ACCESS_TOKEN);
  },
  getRefreshToken: () => {
    return getCookie(StorageKeyEnum.REFRESH_TOKEN);
  },
  isAuthenticated: () => {
    return !!getCookie(StorageKeyEnum.ACCESS_TOKEN);
  },
};

function clearTokens() {
  setCookie(StorageKeyEnum.ACCESS_TOKEN, '', {days: 0});
  setCookie(StorageKeyEnum.REFRESH_TOKEN, '', {days: 0});
}
